import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.animation.registerKeyframes
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { app.bloomey.web.pages.LandingPage() }
        ctx.router.register("/about") { app.bloomey.web.pages.AboutPage() }
        ctx.router.register("/admin/") { app.bloomey.web.pages.admin.DashboardPage() }
        ctx.router.register("/admin/feedbacks") { app.bloomey.web.pages.admin.FeedbacksPage() }
        ctx.router.register("/admin/libraries") { app.bloomey.web.pages.admin.LibrariesPage() }
        ctx.router.register("/admin/login") { app.bloomey.web.pages.admin.LoginPage() }
        ctx.router.register("/admin/users") { app.bloomey.web.pages.admin.UsersPage() }
        ctx.router.register("/admin/videos") { app.bloomey.web.pages.admin.VideosPage() }
        ctx.router.register("/privacy_policy") { app.bloomey.web.pages.Privacy_PolicyPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerComponentStyle(app.bloomey.web.HeadlineTextStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.SubheadlineTextStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.layouts.MarkdownStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.layouts.PageContentStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.sections.FooterStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.sections.NavHeaderStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.widgets.ChartContainerStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.widgets.NavItemStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.widgets.PageButtonStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.widgets.SiteButtonStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.widgets.SiteTableStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.components.widgets.SiteTextInputStyle)
        ctx.theme.registerComponentStyle(app.bloomey.web.pages.SpanStyle)
        ctx.theme.registerComponentVariants(app.bloomey.web.CircleButtonVariant)
        ctx.theme.registerComponentVariants(app.bloomey.web.UncoloredButtonVariant)
        ctx.theme.registerComponentVariants(app.bloomey.web.components.widgets.LogoutIconColorVariant)
        ctx.theme.registerComponentVariants(app.bloomey.web.components.widgets.NavItemActiveVariant)
        ctx.theme.registerComponentVariants(app.bloomey.web.components.widgets.SiteButtonDialogVariant)
        ctx.theme.registerComponentVariants(app.bloomey.web.components.widgets.SiteTextInputSearchVariant)
        ctx.theme.registerComponentVariants(app.bloomey.web.theme.SpanTextHeader1Variant)
        ctx.stylesheet.registerKeyframes(app.bloomey.web.components.sections.SideMenuSlideInLeftRightAnim)
        ctx.stylesheet.registerKeyframes(app.bloomey.web.components.sections.SideMenuSlideInRightLeftAnim)
        ctx.stylesheet.registerKeyframes(app.bloomey.web.components.widgets.SpinLoader)
        app.bloomey.web.initColorMode(ctx)
        app.bloomey.web.initSiteStyles(ctx)
        app.bloomey.web.core.di.initDi(ctx)
        app.bloomey.web.theme.initTheme(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "Bloomey Admin", "PATH" to
            "/opt/homebrew/opt/ruby/bin:/opt/homebrew/lib/ruby/gems/3.0.0/bin:/Users/funyin/google-cloud-sdk/bin:/Users/funyin/Library/Android/sdk/platform-tools:/opt/homebrew/bin:/opt/homebrew/sbin:/usr/local/bin:/System/Cryptexes/App/usr/bin:/usr/bin:/bin:/usr/sbin:/sbin:/usr/local/MacGPG2/bin:/Library/Apple/usr/bin:/var/run/com.apple.security.cryptexd/codex.system/bootstrap/usr/local/bin:/var/run/com.apple.security.cryptexd/codex.system/bootstrap/usr/bin:/var/run/com.apple.security.cryptexd/codex.system/bootstrap/usr/appleinternal/bin:/Users/funyin/.cargo/bin:/Users/funyin/Library/Application Support/JetBrains/Toolbox/scripts:/Users/funyin/.pub-cache/bin",
            "MANPATH" to "/opt/homebrew/share/man::", "JAVA_HOME" to
            "/Users/funyin/Library/Java/JavaVirtualMachines/corretto-17.0.8.1/Contents/Home", "TERM"
            to "xterm-256color", "LANG" to "en_US.UTF-8", "HOMEBREW_PREFIX" to "/opt/homebrew",
            "ANDROID_HOME" to "/Users/funyin/Library/Android/sdk", "COMMAND_MODE" to "unix2003",
            "LOGNAME" to "admin", "HOMEBREW_REPOSITORY" to "/opt/homebrew", "PWD" to
            "/Users/funyin/IdeaProjects/bloomey-web/site", "XPC_SERVICE_NAME" to
            "application.com.jetbrains.intellij.31214141.31218574", "INFOPATH" to
            "/opt/homebrew/share/info:", "__CFBundleIdentifier" to "com.jetbrains.intellij", "SHELL"
            to "/bin/zsh", "OLDPWD" to "/opt/homebrew/Cellar/kobweb/0.9.13/libexec",
            "HOMEBREW_CELLAR" to "/opt/homebrew/Cellar", "SECURITYSESSIONID" to "186a5", "USER" to
            "admin", "TMPDIR" to "/var/folders/s7/7_z3vfpx0k76bf5k4gr07y0h0000gn/T/",
            "LaunchInstanceID" to "851DBEB6-6D5D-4095-98EB-BF099C88B7A7", "SSH_AUTH_SOCK" to
            "/private/tmp/com.apple.launchd.qo88ZRz8dG/Listeners", "XPC_FLAGS" to "0x0",
            "JAVA_MAIN_CLASS_30962" to "MainKt", "LC_ALL" to "en_US.UTF-8",
            "__CF_USER_TEXT_ENCODING" to "0x1F5:0x0:0x0", "SHLVL" to "0", "HOME" to
            "/Users/funyin"))
    renderComposable(rootElementId = "root") {
        app.bloomey.web.AppEntry {
            router.renderActivePage { renderWithDeferred { it() } }
        }
    }
}
